import * as ActionTypes from '../actions/index';
const defaultForm = {
    id: null,
    email: '',
    username: '',
    forename: "",
    surname: "",
    ccEmailAddress: "",
    telephone1: "",
    telephone1Description: "",
    telephone2: "",
    telephone2Description: "",
    brokerFirmId: '',
    addressLine1: '',
    addressLine2: '',
    postCode: '',
    lawsysName: '',
};

const defaultPasswordForm =  {
    password: '',
    newPassword: '',
    retypedNewPassword: '',
};

const defaultState = {
    broker: defaultForm,
    posting: false,
    postFailMessage: '',
    formErrors: [],
    fetching: false,
    patching: false,
    formSuccessMsg: '',
    generalError: '',
    passwordForm: defaultPasswordForm,
    isChangePasswordModalOpen: false,
    updatingPassword: false,
    updatePasswordError: '',
    unlockingUser: false,
    unlockErrorMessage: null,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.UNLOCK_BROKER:
            return {
                ...state,
                unlockingUser: true,
                unlockErrorMessage: null
            };
        case ActionTypes.UNLOCK_BROKER_SUCCESS:
            return {
                ...state,
                unlockingUser: false,
                unlockErrorMessage: null,
                broker: {
                    ...state.broker,
                    isLockedOutUntilUtc: null
                }
            };
        case ActionTypes.UNLOCK_BROKER_FAILED:
            let unlockUserErrorMessage = "";
            try {
                unlockUserErrorMessage = action.payload.response.body.message
            } catch (e) {
                unlockUserErrorMessage = "Failed to unlock solicitor user."
            }
            return {
                ...state,
                unlockingUser: false,
                unlockErrorMessage: unlockUserErrorMessage
            };
        case ActionTypes.UPDATE_BROKER_PASSWORD:
            return {
                ...state,
                updatingPassword: true,
                updatePasswordError: defaultState.updatePasswordError
            };
        case ActionTypes.UPDATE_BROKER_PASSWORD_SUCCESS:
            return {
                ...state,
                updatingPassword: false,
                isChangePasswordModalOpen: false,
                passwordForm: defaultPasswordForm,
                formSuccessMsg: 'Password updated successfully.'
            };
        case ActionTypes.UPDATE_BROKER_PASSWORD_FAILED:
            let changePasswordError = '';
            try {
                changePasswordError = action.payload.response.body.message;
            } catch (e) {
                changePasswordError = 'Failed to update password';
            }
            return {
                ...state,
                updatingPassword: false,
                updatePasswordError: changePasswordError
            };
        case ActionTypes.CHANGE_BROKER_PASSWORD:
            return {
                ...state,
                passwordForm: {
                    ...state.passwordForm,
                    [action.payload.key]: action.payload.value
                },
                updatePasswordError: defaultState.updatePasswordError
            };
        case ActionTypes.OPEN_BROKER_PASSWORD_MODAL:
            return {
                ...state,
                isChangePasswordModalOpen: true,
                formSuccessMsg: defaultState.formSuccessMsg
            };
        case  ActionTypes.CLOSE_BROKER_PASSWORD_MODAL:
            return {
                ...state,
                isChangePasswordModalOpen: false,
                passwordForm: defaultPasswordForm,
                updatePasswordError: defaultState.updatePasswordError
            };
        case ActionTypes.UPDATE_BROKER_BY_ID:
            return {
                ...state,
                patching: true,
                formSuccessMsg: defaultState.formSuccessMsg,
                formErrors: defaultState.formErrors
            };
        case ActionTypes.UPDATE_BROKER_BY_ID_SUCCESS:
            return {
                ...state,
                patching: false,
                formSuccessMsg: 'Updated successfully.'
            };
        case ActionTypes.UPDATE_BROKER_BY_ID_FAILED:
            const patchErrors = [];
            try {
                patchErrors.push(action.payload.response.body.message);
            } catch (e) {
                patchErrors.push('Failed to update');
            }
            return {
                ...state,
                patching: false,
                formErrors: patchErrors
            };
        case ActionTypes.GET_BROKER_BY_ID:
            return {
                ...state,
                fetching: true
            };
        case ActionTypes.GET_BROKER_BY_ID_SUCCESS:
            if(!action.payload.body) return {
                ...defaultState,
                generalError: 'Failed to fetch broker user.'
            };
            return {
                ...state,
                fetching: false,
                broker: {
                    id: action.payload.body.id,
                    userId: action.payload.body.userId,
                    username: action.payload.body.username,
                    email: action.payload.body.email,
                    forename: action.payload.body.forename,
                    surname: action.payload.body.surname,
                    ccEmailAddress: action.payload.body.ccEmail?action.payload.body.ccEmail:'',
                    brokerFirmId: action.payload.body.lawsysId.toString(),
                    telephone1: action.payload.body.telephone1?action.payload.body.telephone1:'',
                    telephone1Description: action.payload.body.telephone1Description?
                        action.payload.body.telephone1Description:'',
                    telephone2: action.payload.body.telephone2?action.payload.body.telephone2:'',
                    telephone2Description: action.payload.body.telephone2Description?
                        action.payload.body.telephone2Description:'',
                    addressLine1: action.payload.body.addressLine1,
                    postCode: action.payload.body.postCode,
                    lawsysName: action.payload.body.lawsysName,
                    isLockedOutUntilUtc: action.payload.body.isLockedOutUntilUtc,
                }
            };
        case ActionTypes.GET_BROKER_BY_ID_FAILED:
            return {
                ...state,
                fetching: false
            };
        case ActionTypes.CHANGE_BROKER_STATE:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case ActionTypes.CREATE_BROKER:
            return {
                ...state,
                posting: true,
                formErrors: defaultState.formErrors,
                formSuccessMsg: defaultState.formSuccessMsg
            };
        case ActionTypes.CREATE_BROKER_SUCCESS:
            return {
                ...state,
                posting: false,
                broker: defaultForm,
                formSuccessMsg: 'Broker User created.'
            };
        case ActionTypes.CREATE_BROKER_FAILED:
            let postErrors = [];
            try {
                postErrors.push(action.payload.response.body.message);
            } catch (e) {
                postErrors.push('Failed to create broker');
            }
            return {
                ...state,
                posting: false,
                formErrors: postErrors
            };
        case ActionTypes.CHANGE_BROKER:
            return {
                ...state,
                formErrors: defaultState.formErrors,
                formSuccessMsg: defaultState.formSuccessMsg,
                broker: {
                    ...state.broker,
                    [action.payload.key]: action.payload.value
                }
            };
        case '@@router/LOCATION_CHANGE':
            return defaultState;
        case ActionTypes.LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}